import { connect } from 'react-redux'

import {
  addAgencyBranding,
  fetchAgencyInfo,
  fetchTeamProperties,
  removeAgencyBranding,
  updateAgency,
} from 'app/bond_cover/agency/agency_actions'
import { changeTeam } from 'app/session/session_actions'
import { fetchProperty } from 'app/sm/ppp/property_actions'
import { fetchAgencyPublicProperties } from 'app/sm/properties/properties_actions'
import {
  fetchTeamSettingInfo,
  updateTeamViewingSettingInfo,
} from 'app/sm/rental_reputation/actions'
import {
  fetchAgencyMembersList,
  fetchAgencyStatusDetails,
  fetchAgencyStatusReport,
  fetchViewingPreference,
  updateViewingPreference,
} from 'app/sm/team_viewing_preference/action'
import TeamViewingPreferenceContainer from 'app/sm/team_viewing_preference/container'
const mapStateToProps = ({ session, agency }) => ({
  teams: session.teams,
  currentAgency: session.currentAgency,
  currentUser: session.currentUser,
  agency: agency.agency,
})

const mapDispatchToProps = (dispatch) => ({
  changeTeam: (team) => dispatch(changeTeam(team)),
  updateViewingPreference: (teamId, preferenceInfo) =>
    dispatch(updateViewingPreference(teamId, preferenceInfo)),
  fetchViewingPreference: (teamId, propertyGUID) =>
    dispatch(fetchViewingPreference(teamId, propertyGUID)),
  fetchTeamSettingInfo: (teamId, queryString) =>
    dispatch(fetchTeamSettingInfo(teamId, queryString)),
  updateTeamViewingSettingInfo: (
    teamId,
    viewingSetting,
    applicationSetting,
    personalNotificationSettings,
    feedSettings,
    _,
    aiToolsInfo,
    brandingSettings,
  ) =>
    dispatch(
      updateTeamViewingSettingInfo(
        teamId,
        viewingSetting,
        applicationSetting,
        personalNotificationSettings,
        feedSettings,
        _,
        aiToolsInfo,
        brandingSettings,
      ),
    ),
  fetchTeamProperties: (teamGUID, filters) =>
    dispatch(fetchTeamProperties(teamGUID, filters)),
  fetchProperty: (id) => dispatch(fetchProperty(id)),
  fetchAgencyMembersList: (agencyGUID) =>
    dispatch(fetchAgencyMembersList(agencyGUID)),
  fetchAgencyStatusDetails: (agencyGUID) =>
    dispatch(fetchAgencyStatusDetails(agencyGUID)),
  fetchAgencyStatusReport: (agencyGUID) =>
    dispatch(fetchAgencyStatusReport(agencyGUID)),
  fetchAgencyPublicProperties: (
    agencySlug,
    address,
    sort,
    sortDir,
    bedroom,
    cursor,
  ) =>
    dispatch(
      fetchAgencyPublicProperties(
        agencySlug,
        address,
        sort,
        sortDir,
        bedroom,
        cursor,
      ),
    ),
  addAgencyBranding: (logoType, agencyGUID, documentType) =>
    dispatch(addAgencyBranding(logoType, agencyGUID, documentType)),
  removeAgencyBranding: (logoType, agencyGUID) =>
    dispatch(removeAgencyBranding(logoType, agencyGUID)),
  updateAgency: (agency) => dispatch(updateAgency(agency)),
  fetchAgencyInfo: (agencyGUID) => dispatch(fetchAgencyInfo(agencyGUID)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TeamViewingPreferenceContainer)
